import { reactive } from "vue";
import { Observable } from "rxjs";
import HomeApi from '@/module/Home/service/HomeApi.js';

const obserInit = new Observable((subscriber) => {
    if (state.isInitial) {
        subscriber.next(state.isInitial);
    } else {
        subInitList.push(subscriber);
    }
});
const subInitList = [];
const state = reactive({
    isInitial: false,
    categoryPopup: null,
});

const methods = {
    init: function() {
        if (state.isInitial == false)
            this.apiPopupCat();
    },
    initStatus: function () {
        return obserInit;
    },
    apiPopupCat: function() {
        HomeApi.apiPopupCat().subscribe({
            next: (data) => {
                state.categoryPopup = []
                if (data.categoryPopup) {
                    state.categoryPopup = data.categoryPopup;
                }
                state.isInitial = true;
                sendEventInit()
            },
            error: (err) => {
                state.isInitial = true;
                console.log(err);
                //this.errorApi(err);
            },
        });
    },
    
}

function sendEventInit() {
    for (let i of subInitList) {
        i.next(state.isInitial);
    }
}

export default {
    state: state,
    methods: methods,
};